module.exports = __webpack_public_path__ + "static/media/ic-face-red-original.a1547549.svg";